import { render, staticRenderFns } from "./PendingPaymentCard.vue?vue&type=template&id=ead460c2&scoped=true"
import script from "./PendingPaymentCard.vue?vue&type=script&lang=js"
export * from "./PendingPaymentCard.vue?vue&type=script&lang=js"
import style0 from "./PendingPaymentCard.vue?vue&type=style&index=0&id=ead460c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ead460c2",
  null
  
)

export default component.exports